import { TokenResponse } from '@bo/ng-auth';
import { UserProfile } from '../../_interfaces/user.interface';
import { BusinessDetailsRequest } from '../../_interfaces/business.interface';

export class UpdatePageTitle {
  static readonly type = '[App] Update page title';
  constructor(public title: string) {}
}

export class ClearAppState {
  static readonly type = '[App] ClearAppState';
}

export class ToggleSideNav {
  static readonly type = '[App] ToggleSideNav';
}

export class CollapseSideNav {
  static readonly type = '[App] CollapseSideNav';
}

export class OpenSideNav {
  static readonly type = '[App] OpenSideNav';
}

export class SetSessionExpired {
  static readonly type = '[App] SessionExpired';
  constructor(public value: boolean) {}
}

/* Initialise App State */

export class SetAppStateFromSignUpPasswordSet {
  static readonly type = '[App] SetAppState from SignUpPasswordSet';
  constructor(public tokens: TokenResponse) {}
}

export class SetAppStateFromPasswordReset {
  static readonly type = '[App] Set app state from sign-up password set';
  constructor(public tokens: TokenResponse) {}
}

/* Reload App State */

export class ReloadAppStateFromInit {
  static readonly type = '[App] ReloadAppState from Init';
}

export class ReloadAppStateFromLogin {
  static readonly type = '[App] ReloadAppState from Login';
}

export abstract class AbstractSetBusinessState {
  constructor(public businessDetails?: BusinessDetailsRequest) {}
}

export class SetBusinessStateFromReloadAppState extends AbstractSetBusinessState {
  static readonly type = '[App] SetBusinessState from ReloadAppState';
}

export class SetBusinessStateFromPaymentComplete extends AbstractSetBusinessState {
  static readonly type = '[App] SetBusinessState from PaymentComplete';
}

/* SetUserState */

export abstract class AbstractSetUserState {
  constructor(public userProfile?: UserProfile) {}
}

export class SetUserStateFromReloadAppState extends AbstractSetUserState {
  static readonly type = '[App] SetUserState from ReloadAppState';
}

export class SetUserStateFromNavigateToDashboard extends AbstractSetUserState {
  static readonly type = '[App] SetUserState from NavigateToDashboard';
}

export class SetUserStateFromProfileLoad extends AbstractSetUserState {
  static readonly type = '[App] SetUserState from Profile Load';
}

export class SetUserStateFromPhoneVerified extends AbstractSetUserState {
  static readonly type = '[App] SetUserState from PhoneVerified';
}

/* DashboardsState */

export class NavigateToDashboardFromSignUpComplete {
  static readonly type = '[App] NavigateToDashboard from SignUpComplete';
}

export class NavigateToDashboardFromLogin {
  static readonly type = '[App] NavigateToDashboard from Login';
}

export class SetAppStateFromAccountLockedGuard {
  static readonly type = '[App] SetAppState from AccountLockGuard';
}

export class SetAppStateFromVerifyPhoneGuard {
  static readonly type = '[App] SetAppState from VerifyPhoneGuard';
}

export class SetAppStateFromAlreadyVerifiedPhoneGuard {
  static readonly type = '[App] SetAppState from AlreadyVerifiedPhoneGuard';
}

export class SetAppStateFromBusinessCertificateGuard {
  static readonly type = '[App] SetAppState from BusinessCertificateGuard';
}

export class SetAppStateFromSubscriptionGuard {
  static readonly type = '[App] SetAppState from SubscriptionGuard';
}

export class SetAppStateFromTermsAcceptedGuard {
  static readonly type = '[App] SetAppState from TermsAcceptedGuard';
}

export class SetAppStateFromKycCompleted {
  static readonly type = '[App] SetAppState from SetAppStateFromKYCGuard';
}

export class SetAppStateFromSubscriptionCardCreated {
  static readonly type = '[App] SetAppState from SubscriptionCardCreated';
}
